<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>

<div class="wrapper">
  <pr-roles [roleCollection]="roleCollection$ | async" />
</div>
